export const ADD_PAYMENT_METHOD = 'page/ADD_PAYMENT_METHOD';
export const ADD_PAYMENT_METHOD_COMPLETED =
    'page/ADD_PAYMENT_METHOD [completed]';

export const TOGGLE_ADD_DEBIT_CARD_FORM = 'page/TOGGLE_ADD_DEBIT_CARD_FORM';

export const CHOOSE_PAYMENT_METHOD = 'page/CHOOSE_PAYMENT_METHOD';
export const CHOOSE_PAYMENT_METHOD_DEBIT_CARD =
    'page/CHOOSE_PAYMENT_METHOD_DEBIT_CARD';
export const CHOOSE_PAYMENT_METHOD_BANK_ACCOUNT =
    'page/CHOOSE_PAYMENT_METHOD_BANK_ACCOUNT';
export const INITIALISE_PAYMENT_METHOD_DEBIT_CARD =
    'page/INITIALISE_PAYMENT_METHOD_DEBIT_CARD';

export const REGISTER_DEBIT_CARD = 'page/REGISTER_DEBIT_CARD';
export const REGISTER_DEBIT_CARD_PENDING = 'page/REGISTER_DEBIT_CARD [pending]';
export const REGISTER_DEBIT_CARD_SUCCESS = 'page/REGISTER_DEBIT_CARD [success]';
export const CARD_TYPE_NOT_DEBIT = 'page/CARD_TYPE_NOT_DEBIT';
export const DEBIT_CARD_FUNDING_REQUIREMENT_COMPLETED =
    'page/DEBIT_CARD_FUNDING_REQUIREMENT [completed]';
export const BANK_ACCOUNT_FUNDING_REQUIREMENT_COMPLETED =
    'page/BANK_ACCOUNT_FUNDING_REQUIREMENT [completed]';
export const HANDLE_STRIPE_FIELD_CHANGE = 'page/HANDLE_STRIPE_FIELD_CHANGE';
export const SHOW_STRIPE_ERROR = 'page/SHOW_STRIPE_ERROR';
export const CLEAR_STRIPE_ERROR = 'page/CLEAR_STRIPE_ERROR';
export const SHOW_STRIPE_BRAND = 'page/SHOW_STRIPE_BRAND';
export const STRIPE_FIELD_COMPLETE = 'page/STRIPE_FIELD_COMPLETE';
export const RESET_PAYMENT_METHOD = 'page/RESET_PAYMENT_METHOD';

export const REGISTER_BANK_ACCOUNT = 'page/REGISTER_BANK_ACCOUNT';
export const REGISTER_DE_BANK_ACCOUNT = 'page/REGISTER_DE_BANK_ACCOUNT';
export const REGISTER_BANK_ACCOUNT_PENDING = `${REGISTER_BANK_ACCOUNT} [pending]`;
export const REGISTER_BANK_ACCOUNT_SUCCESS = `${REGISTER_BANK_ACCOUNT} [success]`;
export const REGISTER_BANK_ACCOUNT_FAIL = `${REGISTER_BANK_ACCOUNT} [fail]`;

export const SELECT_REPAYMENT_ROLE = 'page/SELECT_REPAYMENT_ROLE';

export const HANDLE_3DS_AUTHENTICATION = 'page/HANDLE_3DS_AUTHENTICATION';
export const AUTHENTICATION_FINISHED = 'page/AUTHENTICATION_FINISHED';
export const AUTHENTICATION_FAILED = 'page/AUTHENTICATION_FAILED';

export const SAVE_CARD_NUMBER_ELEMENT = 'page/SAVE_CARD_NUMBER_ELEMENT';

export const REFETCH_PAYMENT_METHOD = 'page/REFETCH_PAYMENT_METHOD';
